export const organizationSlugHeaderName = 'Organization-Slug';
export const organizationDomainHeaderName = 'Organization-Domain';
